/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs */

const en_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefronts synced`)
};

const ar_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهات مُزامنة`)
};

const bn_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সিঙ্কড স্টোরফ্রন্ট`)
};

const de_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefronts synchronisiert`)
};

const es_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escaparates sincronizados`)
};

const fr_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrines synchronisées`)
};

const pt_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrines sincronizadas`)
};

const zh_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`店面已同步`)
};

const tr_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrinler senkronize edildi`)
};

const ru_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Витрины синхронизированы`)
};

const pl_svc_full_stack_web_apps_work_1_metric_0_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zsynchronizowano witryny sklepowe`)
};

/**
* | output |
* | --- |
* | "Storefronts synced" |
*
* @param {Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_work_1_metric_0_label = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Work_1_Metric_0_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
	return en_svc_full_stack_web_apps_work_1_metric_0_label(inputs)
});
export { svc_full_stack_web_apps_work_1_metric_0_label as "svc_full-stack-web-apps_work_1_metric_0_label" }